/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { NotificationsControllerMarkAllAsReadMutationResponse, NotificationsControllerMarkAllAsRead401, NotificationsControllerMarkAllAsRead403, NotificationsControllerMarkAllAsRead404 } from "../../models/notificationsController/NotificationsControllerMarkAllAsRead";

function getNotificationsControllerMarkAllAsReadUrl() {
  const res = { method: 'PATCH', url: `/api/v1/notifications/read-all` as const }  
  return res
}

/**
 * @description Mark all unread notifications for the current user as read.
 * @summary Mark all notifications as read
 * {@link /api/v1/notifications/read-all}
 */
export async function notificationsControllerMarkAllAsRead(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<NotificationsControllerMarkAllAsReadMutationResponse, ResponseErrorConfig<NotificationsControllerMarkAllAsRead401 | NotificationsControllerMarkAllAsRead403 | NotificationsControllerMarkAllAsRead404>, unknown>({ method : "PATCH", url : getNotificationsControllerMarkAllAsReadUrl().url.toString(), ... requestConfig })  
  return res.data
}